// The one status rule per kind of evidence, shared by the new pages and the report
// builder, so an item never reads "Monitor" on one page and "Needs attention" on another.
// Statuses are 'red' | 'amber' | 'green' | 'grey'. A missing item (an empty heatmap cell
// is null) is 'grey' — not enough evidence.

export const STATUS_TEXT = {
  red: 'Needs attention',
  amber: 'Monitor',
  green: 'Positive',
  grey: 'Not enough evidence',
};

export const STATUS_COLOUR = {
  red: '#d96a52',
  amber: '#efc35d',
  green: '#75b685',
  grey: '#d8d5cf',
};

// Below these counts an item is 'grey' — not enough evidence. Exported so the province
// maps grey out the same provinces the heatmaps do.
export const BRAND_MIN_SCORED = 5;
export const FIELD_MIN_CONVERSATIONS = 3;

// Brand (the rule the Help page documents): fewer than five scored conversations is not
// enough; net sentiment below zero needs attention; below +20 or declining mentions is
// monitor; otherwise positive.
export function brandStatus(row) {
  const { total, net_sentiment, lifecycle } = row || {};
  if (Number(total || 0) < BRAND_MIN_SCORED) return 'grey';
  if (Number(net_sentiment) < 0) return 'red';
  if (lifecycle === 'dying' || Number(net_sentiment) < 20) return 'amber';
  return 'green';
}

// Field item (location x crop): fewer than three conversations is not enough; urgency
// 70+ needs attention, 35+ is monitor; otherwise positive.
export function fieldStatus(row) {
  const { conversations, count, urgency } = row || {};
  if (Number(conversations ?? count ?? 0) < FIELD_MIN_CONVERSATIONS) return 'grey';
  if (Number(urgency || 0) >= 70) return 'red';
  if (Number(urgency || 0) >= 35) return 'amber';
  return 'green';
}

// Reviewed conversation-quality score as a whole percentage. Scorecards store either a
// 0-1 fraction or a 0-100 value, so both are accepted. null when not reviewed.
export function qualityPercent(value) {
  if (value == null) return null;
  const n = Number(value);
  return Math.round(n <= 1 ? n * 100 : n);
}
